import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import testimonialRachel from "@/assets/testimonial-rachel.jpg";
import testimonialKevin from "@/assets/testimonial-kevin.jpg";
import testimonialCarole from "@/assets/testimonial-carole.jpg";
import testimonialHeather from "@/assets/testimonial-heather.jpg";
import testimonialJim from "@/assets/testimonial-jim.jpg";
import testimonialTeensKayak from "@/assets/testimonial-teens-kayak.jpg";
import testimonialMomDaughter from "@/assets/testimonial-mom-daughter.jpg";
import testimonialFriendGroup from "@/assets/testimonial-friend-group.jpg";
import testimonialYoungAdults from "@/assets/testimonial-young-adults.jpg";
import testimonialGirlfriends from "@/assets/testimonial-girlfriends.jpg";
import testimonialBachelorette from "@/assets/testimonial-bachelorette.jpg";
import testimonialBigFamily from "@/assets/testimonial-big-family.jpg";
import testimonialCoupleFloat from "@/assets/testimonial-couple-float.jpg";
import testimonialDadKids from "@/assets/testimonial-dad-kids.jpg";
import testimonialMomExpecting from "@/assets/testimonial-mom-expecting.jpg";

const testimonials = [
  {
    quote: "This was so much easier than the river. We'll be back every summer.",
    name: "Rachel",
    location: "Houston",
    image: testimonialRachel,
  },
  {
    quote: "Wow!! What a wonderful place to take the family!",
    name: "Kevin",
    location: "New Braunfels",
    image: testimonialKevin,
  },
  {
    quote: "A bit of paradise in an unexpected location!",
    name: "Carole",
    location: "Austin",
    image: testimonialCarole,
  },
  {
    quote: "Clean, private, no riff-raff. Well worth the money.",
    name: "Jim",
    location: "San Antonio",
    image: testimonialJim,
  },
  {
    quote: "The kids had the best time kayaking and exploring. Already planning our next trip!",
    name: "Sofia",
    location: "Dallas",
    image: testimonialTeensKayak,
  },
  {
    quote: "Such a peaceful spot for mommy-daughter time. We felt so relaxed.",
    name: "Jasmine",
    location: "Round Rock",
    image: testimonialMomDaughter,
  },
  {
    quote: "Perfect for our friend group getaway. The cabana was all ours!",
    name: "Marcus",
    location: "Houston",
    image: testimonialFriendGroup,
  },
  {
    quote: "Best weekend ever! The water was amazing and the vibes were unmatched.",
    name: "Carlos",
    location: "Austin",
    image: testimonialYoungAdults,
  },
  {
    quote: "We come here every year for girls' day. Nothing else compares!",
    name: "Ashley",
    location: "San Marcos",
    image: testimonialGirlfriends,
  },
  {
    quote: "Had my bachelorette here and it was absolutely perfect. Highly recommend!",
    name: "Brittany",
    location: "Seguin",
    image: testimonialBachelorette,
  },
  {
    quote: "Brought the whole family and everyone had a blast. Great for all ages!",
    name: "David",
    location: "Corpus Christi",
    image: testimonialBigFamily,
  },
  {
    quote: "So relaxing floating together. This place is a hidden gem!",
    name: "Maria",
    location: "San Antonio",
    image: testimonialCoupleFloat,
  },
  {
    quote: "Dad of the year award! The kids talked about this trip for weeks.",
    name: "Ryan",
    location: "Waco",
    image: testimonialDadKids,
  },
  {
    quote: "Even while expecting, I felt comfortable and relaxed here. Beautiful spot!",
    name: "Jennifer",
    location: "Boerne",
    image: testimonialMomExpecting,
  },
  {
    quote: "The staff was amazing. The whole experience was awesome!",
    name: "Heather",
    location: "College Station",
    image: testimonialHeather,
  },
];

const Testimonials = () => {
  return (
    <section className="py-20 lg:py-28 bg-primary text-primary-foreground overflow-hidden">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Don't Take Our Word For It
          </h2>
          <div className="flex justify-center gap-1 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-6 h-6 fill-accent text-accent" />
            ))}
          </div>
          <p className="text-lg text-primary-foreground/70">
            Trusted by thousands of Texas families since 2014
          </p>
        </motion.div>

        <div className="relative">
          <div className="flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide -mx-4 px-4">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex-shrink-0 w-80 snap-center"
              >
                <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-2xl overflow-hidden h-full border border-primary-foreground/10">
                  <img
                    src={testimonial.image}
                    alt={`${testimonial.name} enjoying Son's Island`}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-6">
                    <Quote className="w-8 h-8 text-accent mb-4" />
                    <p className="text-lg mb-6 leading-relaxed">"{testimonial.quote}"</p>
                    <div>
                      <p className="font-semibold">{testimonial.name}</p>
                      <p className="text-sm text-primary-foreground/60">{testimonial.location}</p>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
